"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WholesaleIntegrationsClient = void 0;
const core_client_1 = require("@deliverr/core-client");
const openapi_1 = require("./generated-sources/openapi");
class WholesaleIntegrationsClient extends core_client_1.OpenApiGeneratedClient {
    instantiateOpenApiGeneratedApi() {
        //client uses the axios instance created by core client, to avoid compatibility issues
        return new openapi_1.ServiceApi(new openapi_1.Configuration(this.getConfigurationParameters()), undefined, this.axios);
    }
    getDefaultServiceUrlEnvKey() {
        return "WHOLESALE_INTEGRATIONS_API_URL";
    }
    constructor(config = {}) {
        super(config);
    }
    createRetailer(retailerCreate) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().createRetailer(retailerCreate);
        });
    }
    createTradingRelation(tradingPartnerRelationCreationData) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().createTradingRelation(tradingPartnerRelationCreationData);
        });
    }
    getRetailers() {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getRetailers();
        });
    }
    getRoutingReports() {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getRoutingReports();
        });
    }
    getTradingRelation(relationId) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getTradingRelation(relationId);
        });
    }
    getTradingRelations() {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getTradingRelations();
        });
    }
    getUploadUrl(retailer) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getUploadUrl(retailer);
        });
    }
    updateTradingRelation(tradingPartnerRelationUpdateData) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().updateTradingRelation(tradingPartnerRelationUpdateData);
        });
    }
    generateSingleLabel(shipmentId, dskuToQtyMap) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().generateSingleLabel(shipmentId, dskuToQtyMap);
        });
    }
    generateSingleLabelUrl(shipmentId, singleLabelData) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().generateSingleLabelUrl(shipmentId, singleLabelData);
        });
    }
    getPOFiles(ids, statuses, sellerIds, projectionKeys) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getPOFiles(ids, statuses, sellerIds, projectionKeys);
        });
    }
    updatePOFile(id, pOFileUpdateDTO) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().updatePOFile(id, pOFileUpdateDTO);
        });
    }
    updatePOFileByWholesaleOrderId(wholesaleOrderId, updateData) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().updatePOFileByWholesaleOrderId(wholesaleOrderId, updateData);
        });
    }
    getPOFileByWholesaleOrderId(wholesaleOrderId) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getPOFileByWholesaleOrderId(wholesaleOrderId);
        });
    }
    retryPOFiles(retryPOFilesRequestDTO) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().retryPOFiles(retryPOFilesRequestDTO);
        });
    }
    reprocessPOFiles(retryPOFilesRequestDTO) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().reprocessPOFiles(retryPOFilesRequestDTO);
        });
    }
    getPOFileJsonMapper(id) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getPOFileJsonMapper(id);
        });
    }
    createPOFileJsonMapper(poFileJsonMapperCreationDTO) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().createPOFileJsonMapper(poFileJsonMapperCreationDTO);
        });
    }
    getLabelTemplate(templateId) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getLabelTemplate(templateId);
        });
    }
    createLabelTemplate(labelTemplateFile, labelType, description) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().createLabelTemplate(labelTemplateFile, labelType, description);
        });
    }
    getHealthStatus() {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getHealthStatus();
        });
    }
    createAliasesFromCsv(file, sellerId, batchSize) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().createAliasesFromCsv(file, sellerId, batchSize);
        });
    }
    generatePdf(templateId, orderId, sellerId) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().generatePdf(templateId, orderId, sellerId);
        });
    }
    processTestPOFile(pofile) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().processTestPOFile(pofile);
        });
    }
    getLabelTemplateData(orderId) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().getLabelTemplateData(orderId);
        });
    }
    generateBOLsAndUpload(file, sellerId) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().generateBOLsAndUpload(file, sellerId);
        });
    }
    generateBillOfLadingData(file, sellerId) {
        return this.wrapClientOperationExecution(async () => {
            return this.getOpenApiGeneratedApi().generateBillOfLadingData(file, sellerId);
        });
    }
}
exports.WholesaleIntegrationsClient = WholesaleIntegrationsClient;
//# sourceMappingURL=WholesaleIntegrationsClient.js.map